import React from "react";
import AutorizacaoEspecialSteps from "./steps/AutorizacaoEspecialSteps";
import { AutorizacaoEspecialStoreProvider } from '../../../context/AutorizacaoEspecialContext';

export default function AutorizacaoEspecial() {

    return (
        <AutorizacaoEspecialStoreProvider>
            <AutorizacaoEspecialSteps />
        </AutorizacaoEspecialStoreProvider>
    )

}